const checkFunctionExistOrNot = (func) =>
  !!(func && typeof func === 'function');
export default checkFunctionExistOrNot;
